// extracted by mini-css-extract-plugin
export default {"home":"Home_home__OfiC7","loadMore":"Home_loadMore__sbV+G","goBack":"Home_goBack__aKZtl"};